import districts from '../../../common/data/district_data.json';

export const DistrictByID = (id) => {
  return districts.find((dis) => dis.id === id);
};
